module.exports = "<div id=\"active-quote-banner\" class=\"active-quote-section\">\n    <div class=\"container\">\n        <div class=\"row--narrow\">\n            <div><b>This applicant has an existing active quote:</b></div>\n            <div>{{ application.zoho.quoted_product.banner_summary }}</div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/directives/active-quote-banner.html
// module id = 291
// module chunks = 0